// src/components/strumenti/MaterialeSacchi.js — W442. Intonaco, rasante, massetto o colla in sacchi
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, fmt } from "./UiStrumento";
import { materialeASacchi } from "../../utils/calcoliStrumenti";

export default function MaterialeSacchi() {
  const { v, set, n, azzera } = useCampi({ sup:"", sp:"", cons:"", sacco:"25", scarto:"5" });
  const r = materialeASacchi(n("sup"), n("sp"), n("cons"), n("sacco"), n("scarto"));
  return (
    <div>
      <Griglia colonne={2}>
        <Campo etichetta="Superficie (m²)" valore={v.sup} onChange={set("sup")} placeholder="Es. 40"/>
        <Campo etichetta="Spessore (mm)" valore={v.sp} onChange={set("sp")} placeholder="Es. 15"/>
        <Campo etichetta="Consumo (kg/m² per mm di spessore)" valore={v.cons} onChange={set("cons")} placeholder="Es. 1,4" aiuto="Dalla scheda tecnica del prodotto."/>
        <Campo etichetta="Peso del sacco (kg)" valore={v.sacco} onChange={set("sacco")}/>
        <Campo etichetta="Scarto (%)" valore={v.scarto} onChange={set("scarto")}/>
      </Griglia>
      <Risultato settore="geometra" titolo="Sacchi necessari" valore={r?.sacchi !== null && r?.sacchi !== undefined ? String(r.sacchi) : "—"}
        righe={r ? [["Materiale", fmt(r.kg, 1) + " kg"], ["In tonnellate", fmt(r.kg / 1000, 3) + " t"]] : []}/>
      <Formula>kg = superficie × spessore (mm) × consumo (kg/m² per mm) × (1 + scarto); sacchi = kg ÷ peso del sacco, per eccesso. Il consumo cambia da prodotto a prodotto: usa sempre quello della scheda tecnica.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
